import styled from 'styled-components';

export const Currency = styled.span`
    z-index: 1;
    color: grey;
    font-size: 0.8rem;
    margin-left: 1rem;
    margin-right: -0.5rem;
`;
